export const getCDNPath = (path) => {
	return process.env.REACT_APP_STORAGE_URL + path
}